var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync-update-icon",
    transform: "translate(-366 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_881",
    "data-name": "Ellipse 881",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(366 -13)",
    fill: "#2faed7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M16.05,12.05,21,17l-4.95,4.95-1.414-1.414L17.172,18H4V16H17.172l-2.536-2.535Zm-8.1-10L9.364,3.464,6.828,6H20V8H6.828l2.536,2.536L7.95,11.949,3,7Z",
    transform: "translate(374 -5.05)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncUpdateIcon);
export default __webpack_public_path__ + "static/media/sync-update-icon.a0a98ec1e9fb684b9081d2e2c5e2dcfa.svg";
export { ForwardRef as ReactComponent };